import React, { useState } from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import { Button, Confirm, Icon, Table } from "semantic-ui-react";

const CustomerRow = ({ customer, deleteCustomer }) => {
  const [confirm, setConfirm] = useState(false);
  const { customerId, name, domain, status } = customer;

  const confirmDelete = async () => {
    await deleteCustomer(customerId);
    setConfirm(false);
  };

  return (
    <Table.Row>
      <Table.Cell>
        <Link to={`/customers/${customerId}`}>{customerId}</Link>
      </Table.Cell>
      <Table.Cell>{name}</Table.Cell>
      <Table.Cell>{domain}</Table.Cell>
      <Table.Cell>{status}</Table.Cell>
      <Table.Cell />
      <Table.Cell collapsing>
        <Button
          icon
          size="small"
          color="red"
          onClick={() => {
            setConfirm(true);
          }}
        >
          <Icon name="delete" />
        </Button>
        <Confirm
          open={confirm}
          onConfirm={confirmDelete}
          onCancel={() => setConfirm(false)}
          header="Delete Customer"
          content={`Are you sure you want to delete customer '${customerId}'?`}
        />
      </Table.Cell>
    </Table.Row>
  );
};

CustomerRow.propTypes = {
  customer: PropTypes.shape({
    customerId: PropTypes.string,
    name: PropTypes.string,
    domain: PropTypes.string,
    status: PropTypes.string
  }).isRequired,
  deleteCustomer: PropTypes.func.isRequired
};

export default CustomerRow;
